import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Inject,
  OnDestroy,
  ViewChild
} from '@angular/core';
import { ViverosFormComponent } from '../viveros-form.component';
import { Store, select } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { NotificationService } from 'projects/registro-personas-empresas/src/app/core/core.module';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ViveroGrupoEspecie } from '../../entity-viveros-grupo-especie.model';
import { State } from '../../../../vista-usuario/vista-usuario.state';
import {
  entityViverosGrupoEspecieAddRequest,
  entityViverosGrupoEspecieChangeRequest
} from '../../entity-viveros-grupo-especie.actions';
import { selectViverosGrupoEspecieCurrentEmpresa } from '../../entity-viveros-grupo-especie.selectors';
import { ViveroFormInput } from '../../models/entity-viveros-grupo-especie.models';
import { FormActionType } from '@rpe/registro-personas-empresas-lib';

@Component({
  selector: 'rpe-registro-actividad-vivero-form-container',
  templateUrl: './registro-actividad-vivero-form-container.component.html',
  styleUrls: ['./registro-actividad-vivero-form-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RegistroActividadViveroFormContainerComponent
  implements OnInit, OnDestroy
{
  @ViewChild(ViverosFormComponent)
  formComponent: ViverosFormComponent;

  subscriptions: Subscription[] = [];

  vivero: ViveroGrupoEspecie = null;
  viverosCurrentEmpresa: ViveroGrupoEspecie[] = [];

  formInvalid: boolean = false;

  newVivero: ViveroGrupoEspecie = null;

  get viveroGrupoEspecieInput(): ViveroFormInput {
    return {
      vivero: this.vivero
    };
  }

  constructor(
    private store: Store<State>,
    private notificationService: NotificationService,
    private dialogRef: MatDialogRef<RegistroActividadViveroFormContainerComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      vivero?: ViveroGrupoEspecie;
      type: FormActionType;
    }
  ) {}

  ngOnInit(): void {
    const sub = this.store
      .pipe(select(selectViverosGrupoEspecieCurrentEmpresa))
      .subscribe((vivero) => {
        this.viverosCurrentEmpresa = vivero;
      });

    this.subscriptions.push(sub);

    if (this.data?.vivero) {
      this.vivero = this.viverosCurrentEmpresa.find(
        (v) => v.id === this.data?.vivero.id
      );
    }
  }

  ngOnDestroy(): void {
    if (this.subscriptions.length) {
      this.subscriptions.forEach((s) => s.unsubscribe());
    }
  }

  formStatusChange(status: string): void {
    if (status === 'INVALID') {
      this.formInvalid = true;
    }

    if (status === 'VALID') {
      this.formInvalid = false;
    }
  }

  formValueChange($event: ViveroGrupoEspecie): void {
    if ($event.id) {
      const editedLab = this.viverosCurrentEmpresa.find(
        (lab) => lab.id === $event.id
      );

      this.viverosCurrentEmpresa = this.viverosCurrentEmpresa.filter(
        (lab) => lab.id != editedLab.id
      );

      this.viverosCurrentEmpresa = [...this.viverosCurrentEmpresa, $event];
    }

    if (!$event.id) {
      this.newVivero = $event;
    }
  }

  onAdd(): void {
    if (this.formInvalid) {
      this.notificationService.info('Complete los campos requeridos');
      this.formComponent?.onShowErrors();
      return;
    }

    // Agregar vivero a la lista si es nuevo
    if (this.newVivero) {
      this.viverosCurrentEmpresa = [
        ...this.viverosCurrentEmpresa,
        this.newVivero
      ];
    }

    if (this.data.type === FormActionType.Add) {
      this.store.dispatch(
        entityViverosGrupoEspecieAddRequest({
          item: this.viverosCurrentEmpresa.map((vivero) => {
            return {
              ...vivero,
              id: vivero.id
            };
          })
        })
      );
    }

    if (this.data.type === FormActionType.Update) {
      this.store.dispatch(
        entityViverosGrupoEspecieChangeRequest({
          item: this.viverosCurrentEmpresa.map((vivero) => {
            return {
              ...vivero,
              id: vivero.id
            };
          })
        })
      );
    }

    this.dialogRef.close();
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
